import { siteMonitorings, siteMonitoring, notes, tags } from './siteMonitoring/siteMonitoringReducer';
import { changePassword } from './users/usersReducer';

export default {
    siteMonitorings,
    siteMonitoring,
    notes,
    tags,
    changePassword
};
